import { AppraisalDocumentTypes, AppraisalOrderTypes, AppraisalPurposes } from '../enums';

export interface RelatedDeliverableDto {
  id: number;
  appraisalDocumentType: AppraisalDocumentTypes;
  orderTypes: AppraisalOrderTypes[];
  purposes: AppraisalPurposes[];
  isAutogenerated: boolean;
}
